import React from 'react';

const DashboardCard = ({ title, children }) => (
    <div
        className="mt-4 py-2 px-2 rounded realEstateDashboardCard"     
    >
        <h2 className="fs-4 fw-bold">{title}</h2>
        {children}
    </div>
);

export default DashboardCard;
